import { createFileRoute } from '@tanstack/react-router'

import { StripeReturnPage } from '@/pages/settings/organization/StripeReturnPage'

export const Route = createFileRoute(
  '/_authenticated/_dashboard/settings/organization/payment-options/stripe/return/',
)({
  component: StripeReturnPage,
})
